/**
 * Construit le href relatif d'une route applicative (préfixe BASE_URL Vite).
 * Utilisable pour `<a href>` vers une autre UL en nouvel onglet.
 */
export function u2000BuildAppRouteHref(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const base = (import.meta.env.BASE_URL ?? '/').replace(/\/$/, '');
  return `${base}${normalized}`;
}

/**
 * Construit l'URL absolue d'une route applicative (origin + BASE_URL + path).
 */
export function u2000BuildAppRouteUrl(path: string): string {
  return `${window.location.origin}${u2000BuildAppRouteHref(path)}`;
}

/**
 * Ouvre une route applicative dans un nouvel onglet navigateur.
 * Utilisable pour dupliquer le contexte SPA (ex. logo menu, liens inter-UL).
 */
export function u2000OpenAppRouteInNewTab(path: string, options?: { focus?: boolean }): void {
  const url = u2000BuildAppRouteUrl(path);
  if (options?.focus) {
    const newWindow = window.open(url, '_blank');
    newWindow?.focus();
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
